module.exports = __webpack_public_path__ + "static/media/loading.fed1ff8b.gif";